/**
 * PhotoSwipe Bridge for FoxTheme
 * Assigns the locally-loaded PhotoSwipe to the FoxTheme namespace.
 * photoswipe.js is loaded via a defer script tag before this file,
 * so window.PhotoSwipe and window.PhotoSwipeLightbox are already defined.
 */
(function () {
  'use strict';
  window.FoxTheme = window.FoxTheme || {};
  if (window.PhotoSwipeLightbox && window.PhotoSwipe) {
    window.FoxTheme.PhotoSwipeLightbox = window.PhotoSwipeLightbox;
    window.FoxTheme.PhotoSwipe = window.PhotoSwipe;
  }
})();
